<template>
  <div>
    <Form
      @submit.native.prevent
      ref="modalForm"
      :model="formData"
      label-position="left"
      class="clearfix"
    >
      <Button class="fr ml32" type="primary" @click="handleEdit(null)">添加奖项</Button>

      <FormItem label="是否开启抽奖" class="fr ml32" :label-width="110">
        <!-- <i-switch @on-change="handleOpen" v-model="formData.open_lottery_flag"></i-switch> -->
        <RadioGroup v-model.trim="formData.open_lottery_flag">
          <div
            style="width:72px;height:34px;position:absolute;left:0;top:0;z-index:999;"
            @click="handleOpen(formData.open_lottery_flag)"
          ></div>
          <Radio :label="1">是</Radio>
          <Radio :label="0">否</Radio>
        </RadioGroup>
      </FormItem>
      <p class="fr red" style="margin-top:6px;">第一个奖项为正上方0点方向，第二个奖项为顺时针第二个，以此类推。奖项数量必须为6、8、10三种</p>
    </Form>

    <Table :loading="tableLoading" class="mt24" :columns="columns" :data="tableData"></Table>
    <!-- 设置奖项弹窗 -->
    <Modal
      v-model="modalVisibile"
      width="584"
      :mask-closable="false"
      :title="modalTitle"
      @on-cancel="handleCancel"
    >
      <Form
        @submit.native.prevent
        ref="modalForm"
        :model="modalForm"
        :rules="modalRule"
        inline
        label-position="top"
      >
        <div class="clearfix">
          <FormItem label="排序:" class="fl">
            <Input v-model="modalForm.order_no" class="w240" type="number"></Input>
          </FormItem>
          <FormItem label="中奖概率:" class="fr w240" style="position:relative;">
            <Input v-model="modalForm.rate" :disabled="formData.open_lottery_flag==1"></Input>
            <span class="ratePlace">%</span>
          </FormItem>
        </div>

        <div class="clearfix">
          <FormItem label="奖品类别" class="fl">
            <Select
              class="w240"
              v-model.trim="modalForm.lottery"
              @on-change="handleType(modalForm.lottery)"
            >
              <Option :value="item.id" v-for="(item,index) in prizeType" :key="index">{{item.value}}</Option>
            </Select>
          </FormItem>
          <!-- 1：积分，2：欢乐豆，3：优惠券 -->
          <FormItem label="数值" class="fr">
            <!-- 优惠券时下拉 -->
            <Select class="w240" v-model.trim="modalForm.price" v-show="modalForm.lottery===3">
              <Option
                :value="item.cash_money"
                v-for="(item,index) in cashBox"
                :key="index"
              >{{item.cash_money}}</Option>
            </Select>

            <Input v-model="modalForm.price" class="w240" v-if="modalForm.lottery!=3"></Input>

          </FormItem>
        </div>

        <div class="clearfix">
          <div class="fl w240">
            <FormItem label="奖品图标" class="fl">
              <!-- 优惠券奖品图标 -->
              <div class="shadowIconBox shadowIconActive" v-show="modalForm.lottery===3">
                <img :src="cashImg" />
              </div>
              <!-- 欢乐豆 -->
              <div
                :class="['shadowIconBox',iconType===1? 'shadowIconActive':'']"
                v-show="modalForm.lottery===2"
                @click.prevent="handleIcon(1)"
              >
                <img :src="beansLittleImg" />
              </div>
              <div
                :class="['shadowIconBox','ml20',iconType===2? 'shadowIconActive':'']"
                v-show="modalForm.lottery===2"
                @click.prevent="handleIcon(2)"
              >
                <img :src="beansBigImg
" />
              </div>

              <!-- 积分 -->
              <div
                :class="['shadowIconBox',iconType===3? 'shadowIconActive':'']"
                v-show="modalForm.lottery===1"
                @click.prevent="handleIcon(3)"
              >
                <img :src="jifenLittleImg" />
              </div>
              <div
                :class="['shadowIconBox','ml20',iconType===4? 'shadowIconActive':'']"
                v-show="modalForm.lottery===1"
                @click.prevent="handleIcon(4)"
              >
                <img :src="jifenBigImg" />
              </div>             
            </FormItem>
            <FormItem label="弹窗图标" class="fr">
              <div class="shadowIconBox shadowIconActive">
                <img v-show="modalForm.lottery===3" :src="cashImgPopup" alt />
                <!-- 欢乐豆少弹层 -->
                <img v-show="modalForm.lottery===2&&iconType===1" :src="beansLittleImgPop" alt />
                <!-- 欢乐豆多弹层 -->
                <img v-show="modalForm.lottery===2&&iconType===2" :src="beansBigImgPop" />

                <!-- 积分少弹层 -->
                <img v-show="modalForm.lottery===1&&iconType===3" :src="jifenLittleImgPop" alt />
                <!-- 积分多弹层 -->
                <img v-show="modalForm.lottery===1&&iconType===4" :src="jifenBigImgPop" alt />
              </div>
            </FormItem>
          </div>

          <div class="w240 fr">
            <FormItem label="是否为大奖" class>
              <RadioGroup v-model.trim="modalForm.big_lottery_flag">
                <Radio :label="1">是</Radio>
                <Radio :label="0">否</Radio>
              </RadioGroup>
            </FormItem>
          </div>
        </div>
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button :loading="modalLoading" type="primary" @click="handleModalSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import mixins from "@/mixins/page";
export default {
  name: "setPrize",
  mixins: [mixins],
  data() {
    const validatePhome = (rule, value, callback) => {
      if (isNaN(value - 0)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      modalTitle: "",
      //奖项概率是否是100%状态
      prizeRateStatus: false,
      //奖项数量状态
      prizeLengthStatus: false,
      isClick: true,
      //图标标识
      iconType: null,
      //优惠券图标
      cashImg:
        "http://zqcf718.com/3e338ca1eb414d63a40a34ab2eab8a87?e=1897355805&token=Lix9HHSQrTTVYqLG3aaUvJPNB3uBoz9GtxCqMS5G:FcwzwpwDizNQNd7EgnSawx9lktI=",
      //优惠券弹窗图标
      cashImgPopup:
        "http://zqcf718.com/036de9db7608441c96cfa1da9833c751?e=1897355833&token=Lix9HHSQrTTVYqLG3aaUvJPNB3uBoz9GtxCqMS5G:UpVJn7FEtOHBLab5lmsbo-dAD34=",

      //欢乐豆少图标
      beansLittleImg:
        "http://zqcf718.com/d0a0bd63ce25411aa40df851e07548c2?e=1897353941&token=Lix9HHSQrTTVYqLG3aaUvJPNB3uBoz9GtxCqMS5G:sJfr36lZ_G6PAke1qo-g405ttLM=",
      //欢乐豆多图标
      beansBigImg:
        "http://zqcf718.com/7917906cba6b441c82914c53a723092a?e=1897354185&token=Lix9HHSQrTTVYqLG3aaUvJPNB3uBoz9GtxCqMS5G:VL_wEU9T-S1gTFV3KvCVGTKOLW8=",
      //欢乐豆少弹层图标
      beansLittleImgPop:
        "http://zqcf718.com/6842c6246d3f4c01adae8846276227f0?e=1897354212&token=Lix9HHSQrTTVYqLG3aaUvJPNB3uBoz9GtxCqMS5G:1vDVOcu7Vs9FFZE5N0h6zVEmmeg=",
      //欢乐豆多弹层图标
      beansBigImgPop:
        "http://zqcf718.com/629bf4c513714f81afaaff1659202291?e=1897354236&token=Lix9HHSQrTTVYqLG3aaUvJPNB3uBoz9GtxCqMS5G:xOVqgzAwkMbKHOEvCsHy1JZKdGM=",
      //积分少图标
      jifenLittleImg:
        "http://zqcf718.com/73e495a6703f44fa91730839e67f13a9?e=1897355871&token=Lix9HHSQrTTVYqLG3aaUvJPNB3uBoz9GtxCqMS5G:dZeEwWZmtxWl4o67AkqGJFVfElU=",
      //积分多图标
      jifenBigImg:
        "http://zqcf718.com/102b9481ec774234a0cec71b9553edca?e=1897355913&token=Lix9HHSQrTTVYqLG3aaUvJPNB3uBoz9GtxCqMS5G:Hf786jMfJ_xsA5QJXlKGD11GXxk=",
      //积分少弹层图标
      jifenLittleImgPop:
        "http://zqcf718.com/476dd2bf006544ef9faa36f47dfa0643?e=1897355957&token=Lix9HHSQrTTVYqLG3aaUvJPNB3uBoz9GtxCqMS5G:Rhdro6rbitCMmlS974vFWXcrD_o=",
      jifenBigImgPop:
        "http://zqcf718.com/e1a71a06c6164c19a3f198e49fc4b419?e=1897355981&token=Lix9HHSQrTTVYqLG3aaUvJPNB3uBoz9GtxCqMS5G:Z2yOQNBcVS7Hc5-vOMnCP7gt36Q=",
      //奖项详情列表
      prizeList: [],
      //优惠券面值
      cashBox: [],
      //奖项类型
      prizeType: [],
      //奖项数量
      prizeNum: [],
      isAdmin: Number(localStorage.getItem("sa")),
      modalVisibile: false,
      modalLoading: false,
      isShowEnd: true,
      formData: {
        open_lottery_flag: 0
      },
      formData1: {
        open_lottery_flag: 0
      },
      modalForm: {
        lottery: 3,
        lottery_icon: "", //奖品图标
        alert_icon: "", //弹窗图标
        big_lottery_flag: 0,
        price: ''
      },
      modalForm1: {
        lottery: 3,
        lottery_icon: "", //奖品图标
        alert_icon: "", //弹窗图标
        big_lottery_flag: 0,
        price: ''
      },
      tableData: [],
      // jsonParam: [],
      modalRule: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          { validator: validatePhome, trigger: "blur" }
        ]
      },
      columns: [
        {
          title: "顺序",
          key: "order_no",
          align: "center"
        },
        {
          title: "图标",
          key: "lottery_icon",
          render: (h, params) => {
            return h("img", {
              class: {
                table_pic: true
              },
              domProps: {
                src: params.row.lottery_icon
              }
            });
          }
        },
        {
          title: "奖项",
          key: "lottery",
          align: "center",
          render: (h, params) => {
            let content = "";
            if (params.row.lottery === 3) {
              content = "优惠券";
            } else if (params.row.lottery === 2) {
              content = "欢乐豆";
            } else if (params.row.lottery === 1) {
              content = "积分";
            }
            return h("span", content);
          }
        },
        {
          title: "数值",
          key: "price",
          align: "center"
        },
        {
          title: "中奖概率",
          key: "rate",
          align: "center",
          render: (h, params) => {
            return h("span", params.row.rate + "%");
          }
        },
        {
          title: "是否为大奖",
          key: "discount",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              {
                class: {
                  red: params.row.big_lottery_flag ? true : false
                }
              },
              params.row.big_lottery_flag ? "是" : "否"
            );
          }
        },
        {
          title: "操作",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  class: {
                    btn_edit: true
                  },
                  on: {
                    click: () => this.handleEdit(params)
                  }
                },
                "编辑"
              ),
              h("i", {
                class: {
                  sline: true
                }
              }),
              h(
                "span",
                {
                  class: {
                    btn_del: true
                  },
                  on: {
                    click: () => this.handleDel(params)
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  mounted() {
    this.handleQuery();
    this.getPrize();
  },
  methods: {
    //开启奖项
    handleOpen(params) {
      ``;
      let title = "";
      let content = "";
      //需要开启
      if (!params) {
        if (!this.prizeLengthStatus) {
          this.$Message.warning("请务必将奖项数量设置为6条或8条或10条！");
          return;
        } else if (!this.prizeRateStatus) {
          this.$Message.warning("总中奖率不是100%，请重新设置！");
          return;
        }
        title = "开启奖项";
        content = "您确定要开启抽奖吗?";
      } else {
        title = "关闭奖项";
        content = "您确定要关闭抽奖吗?";
      }
      this.$Modal.confirm({
        render: h => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true
                }
              },
              title
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true
                }
              },
              content
            )
          ]);
        },
        onOk: () => {
          this.$api
            .openOffPrize({
              open_lottery_flag: this.formData.open_lottery_flag ? 0 : 1
            })
            .then(res => {
              if (res.code === 0) {
                this.$Message.success(res.msg);
                if (this.formData.open_lottery_flag) {
                  this.formData.open_lottery_flag = 0;
                } else {
                  this.formData.open_lottery_flag = 1;
                }
              } else {
                this.$Message.error(res.msg);
              }
            });
        }
      });
    },
    //点击图标
    handleIcon(type) {
      this.iconType = type;
    },
    //选择奖项类别
    handleType(id) {
      if (id === 2) {
        //欢乐豆
        this.iconType = 1;
        this.modalForm.price = "";
      } else if (id === 1) {
        //积分
        this.iconType = 3;
        this.modalForm.price = "";
      } else {
        //优惠券
          this.modalForm.price = this.cashBox[0].cash_money;
      }
    },
    // 删除
    handleDel(params) {
      if (this.formData.open_lottery_flag) {
        this.$Message.warning("请先关闭抽奖再进行操作");
        return;
      }
      this.$Modal.confirm({
        render: h => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true
                }
              },
              "删除奖项"
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true
                }
              },
              "确定要删除该奖项吗?"
            )
          ]);
        },
        onOk: () => {
          this.$api
            .delPrize({
              id: params.row.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$Message.success(res.msg);
                this.handleQuery();
              } else {
                this.$Message.error(res.msg);
              }
            });
        }
      });
    },
    handleReset() {
      this.formData = Object.assign({}, this.formData1);
      this.handleQuery();
    },
    handleCancel() {
      this.modalVisibile = false;
      this.modalForm = Object.assign({}, this.modalForm1);
      console.log(this.modalForm.price)
    },
    //添加和编辑
    handleEdit(params) {
      if (params) {
        this.modalVisibile = true;
        //编辑
        this.modalTitle = "编辑奖项";
        this.modalForm.lottery = params.row.lottery;
        this.modalForm.id = params.row.id;
        this.modalForm.order_no = params.row.order_no;
        this.modalForm.rate = params.row.rate;
        this.modalForm.price = params.row.price;
        this.modalForm.big_lottery_flag = params.row.big_lottery_flag;

        //图标默认展示
        if (this.modalForm.lottery === 2) {
          //欢乐豆
          if (params.row.lottery_icon === this.beansLittleImg) {
            //少
            this.iconType = 1;
          } else {
            //多
            this.iconType = 2;
          }
        } else if (this.modalForm.lottery === 1) {
          //积分
          if (params.row.lottery_icon === this.jifenLittleImg) {
            //少
            this.iconType = 3;
          } else {
            //多
            this.iconType = 4;
          }
        }
      } else {
        if (this.formData.open_lottery_flag) {
          this.$Message.warning("请先关闭抽奖再进行操作");
          return;
        }
        this.modalVisibile = true;
        //新增
        this.modalTitle = "添加奖项";
        //图标默认展示
        if (this.modalForm.lottery === 2) {
          //欢乐豆
          this.iconType = 1;
        } else if (this.modalForm.lottery === 1) {
          //积分
          this.iconType = 3;
        }
      }
    },
    getPrize() {
      //获取奖项类别
      this.$api.getPrizeNum({ dict_type: 1 }).then(res => {
        if (res.code === 0) {
          this.prizeType = res.data;
        } else {
          this.$Message.error(res.msg);
        }
      });
      //获取奖项数量
      this.$api.getPrizeNum({ dict_type: 3 }).then(res => {
        if (res.code === 0) {
          this.prizeNum = res.data;
        } else {
          this.$Message.error(res.msg);
        }
      });
      //获取优惠券面值
      this.$api.getAllCoupons({}).then(res => {
        this.cashBox = res.data;
        // this.modalForm.price = res.data[0].cash_money;
      });
    },
    handleModalSubmit() {
      if (
         this.modalForm.order_no.length==0 ||
        !this.modalForm.rate ||
        !this.modalForm.price
      ) {
        this.$Message.warning("请把奖项内容填写完整！");
        return;
      }
      this.modalLoading = true;
      //3 优惠券  2 欢乐豆  1积分
      if (this.modalForm.lottery === 3) {
        this.modalForm.lottery_icon = this.cashImg;
        this.modalForm.alert_icon = this.cashImgPopup;
      } else if (this.modalForm.lottery === 2 && this.iconType === 1) {
        //欢乐豆少
        this.modalForm.lottery_icon = this.beansLittleImg;
        this.modalForm.alert_icon = this.beansLittleImgPop;
      } else if (this.modalForm.lottery === 2 && this.iconType === 2) {
        //欢乐豆多
        this.modalForm.lottery_icon = this.beansBigImg;
        this.modalForm.alert_icon = this.beansBigImgPop;
      } else if (this.modalForm.lottery === 1 && this.iconType === 3) {
        //积分少
        this.modalForm.lottery_icon = this.jifenLittleImg;
        this.modalForm.alert_icon = this.jifenLittleImgPop;
      } else if (this.modalForm.lottery === 1 && this.iconType === 4) {
        //jifenLittleImg
        //积分少
        this.modalForm.lottery_icon = this.jifenBigImg;
        this.modalForm.alert_icon = this.jifenBigImgPop;
      }
      if (this.modalTitle === "添加奖项") {
        this.$api.addPrize({ ...this.modalForm }).then(res => {
          if (res.code == 0) {
            this.handleQuery();
            this.handleCancel();
            this.getPrize();
          } else {
            this.$Message.error(res.data);
          }
          this.modalLoading = false;
        });
      } else {
        this.$api.editPrize({ ...this.modalForm }).then(res => {
          if (res.code == 0) {
            this.handleQuery();
            this.handleCancel();
            this.getPrize();
          } else {
            this.$Message.error(res.data);
          }
          this.modalLoading = false;
        });
      }
    },
    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      this.$api.getPrizeList({}).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.record;
          this.formData.open_lottery_flag = res.data.open_lottery_flag;
          //概率是否是100%
          if (res.data.is_percent) {
            this.prizeRateStatus = true;
          } else {
            this.prizeRateStatus = false;
          }
          //奖项数量状态
          if (
            res.data.record.length === 6 ||
            res.data.record.length === 8 ||
            res.data.record.length === 10
          ) {
            this.prizeLengthStatus = true;
          } else {
            this.prizeLengthStatus = false;
          }
          if (this.prizeRateStatus && this.prizeLengthStatus) {
            this.isClick = false;
          } else {
            this.isClick = true;
          }
        } else {
          this.$Message.error(res.msg);
        }
        this.tableLoading = false;
      });
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-modal-body {
  padding-bottom: 0;
}
/deep/ .table_pic {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
}
/deep/.ivu-input[disabled],
fieldset[disabled] .ivu-input {
  color: #515a6e;
}
.lastInput {
  margin-left: 40px;
}
.lastInput1 {
  margin-left: 128px;
}
/deep/ivu-form-item-content {
  margin-left: 0 !important;
}
.bigLine {
  width: 107%;
  position: relative;
  left: -32px;
  height: 12px;
  background: #f0f3f5;
}
.w160 {
  width: 160px;
}
.disIb {
  display: inline-block;
}
.selectIcon {
  div {
    width: 56px;
    height: 56px;
    border: 1px solid #dce1e6;
    border-radius: 4px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.w90 {
  width: 90px;
}
/deep/ .h48 .ivu-select-selection {
  height: 48px !important;
}
/deep/.h48 .ivu-select-selection .ivu-select-selected-value {
  opacity: 0;
}
.selectedImgBox {
  position: relative;
}
.selectedImg {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  z-index: 999;
}

.shadowIconBox {
  width: 48px;
  height: 48px;
  border: 1px solid #dce1e6;
  border-radius: 4px;
  display: inline-block;
  img {
    width: 100%;
    height: 100%;
  }
}
.shadowIconActive {
  border: 1px solid #1890ff;
  display: inline-block;
}

.ratePlace {
  position: absolute;
  right: 10px;
}
/deep/.ivu-form-inline .ivu-form-item {
  margin-right: 0;
}
</style>
